export const formatDate = (date: string | undefined) =>
  date ? new Intl.DateTimeFormat().format(new Date(date)) : undefined
